import {
  ACCOUNT_DOCUMENT_STATUS_DISPLAY,
  AccountDocumentBasicResponse,
  AccountDocumentStatusEnum,
} from '@monetize/types/app';
import { createColumnHelper } from '../../../components/Monetize/DataTableNew/appTable';
import { actionCatalogColumn } from '../../../components/Monetize/DataTableNew/columnCatalog/structuralColumns';
import {
  ColumnCatalog,
  ColumnContextBase,
} from '../../../components/Monetize/DataTableNew/columnCatalog/types';
import {
  dateTimeBodyTemplate,
  enumDisplayBodyTemplate,
  getColHeaderFilters,
  getColHeaderWithSize,
  getColumnFilterValuesForEnum,
  nameWithIdBodyTemplate,
} from '../../../components/Monetize/DataTableNew/tableUtilsNew';
import { getAccountDocumentDetails } from '../../../constants/routes';

const columnHelper = createColumnHelper<AccountDocumentBasicResponse>();

const statusValues = getColumnFilterValuesForEnum(
  AccountDocumentStatusEnum,
  ACCOUNT_DOCUMENT_STATUS_DISPLAY,
);

export interface AccountDocumentListColumnContext extends ColumnContextBase<AccountDocumentBasicResponse> {
  accountId: string;
}

/** tableId: local filter state (no FilterStateKeys) */
export const ACCOUNT_DOCUMENT_LIST_CATALOG: ColumnCatalog<
  AccountDocumentBasicResponse,
  AccountDocumentListColumnContext
> = [
  {
    id: 'name',
    label: 'Name',
    customizable: false,
    build: ({ accountId }) =>
      columnHelper.accessor('name', {
        ...getColHeaderWithSize('Name', 250),
        ...getColHeaderFilters('TEXT'),
        cell: nameWithIdBodyTemplate<AccountDocumentBasicResponse, string>({
          nameProp: 'name',
          idProp: 'id',
          idLinkFn: (id) => getAccountDocumentDetails(accountId, id),
        }),
        enableSorting: true,
      }),
  },
  {
    id: 'sentAt',
    label: 'Sent At',
    build: () =>
      columnHelper.accessor('sentAt', {
        ...getColHeaderWithSize('Sent At', 150),
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'signedAt',
    label: 'Signed At',
    build: () =>
      columnHelper.accessor('signedAt', {
        ...getColHeaderWithSize('Signed At', 150),
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'status',
    label: 'Status',
    build: () =>
      columnHelper.accessor('status', {
        ...getColHeaderWithSize('Status', 150),
        ...getColHeaderFilters('SET', { predefinedFilterValues: statusValues }),
        cell: enumDisplayBodyTemplate({
          displayMap: ACCOUNT_DOCUMENT_STATUS_DISPLAY,
          styleMap: {
            [AccountDocumentStatusEnum.CREATED]: {
              color: 'tGray.darkGrayPurple',
              bgColor: 'transparent',
            },
            [AccountDocumentStatusEnum.SENT]: {
              color: 'tGray.darkGrayPurple',
            },
            [AccountDocumentStatusEnum.SIGNED]: {
              color: 'tGreen.mDarkShade',
            },
          },
        }),
        enableSorting: true,
      }),
  },
  {
    id: 'modifyDate',
    label: 'Updated',
    build: () =>
      columnHelper.accessor('modifyDate', {
        ...getColHeaderWithSize('Updated', 170),
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'createDate',
    label: 'Created',
    build: () =>
      columnHelper.accessor('createDate', {
        ...getColHeaderWithSize('Created', 170),
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
        enableSorting: true,
      }),
  },
  actionCatalogColumn<AccountDocumentBasicResponse>(),
];
